export function hashString(input: string): number {
  let h = 2166136261 >>> 0;
  for (let index = 0; index < input.length; index += 1) {
    h ^= input.charCodeAt(index);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function mulberry32(seed: number): () => number {
  let value = seed >>> 0;
  return () => {
    value |= 0;
    value = (value + 0x6d2b79f5) | 0;
    let result = Math.imul(value ^ (value >>> 15), 1 | value);
    result = (result + Math.imul(result ^ (result >>> 7), 61 | result)) ^ result;
    return ((result ^ (result >>> 14)) >>> 0) / 4294967296;
  };
}

export function stream(seed: string, namespace: string, counter = 0): () => number {
  return mulberry32(hashString(`${seed}::${namespace}::${counter}`));
}

export function randomInt(min: number, max: number, rng: () => number): number {
  return min + Math.floor(rng() * (max - min + 1));
}

export function pick<T>(items: readonly T[], rng: () => number): T {
  if (!items.length) throw new Error("Cannot select from an empty list");
  return items[Math.floor(rng() * items.length) % items.length];
}

export function shuffle<T>(items: readonly T[], rng: () => number): T[] {
  const copy = [...items];
  for (let index = copy.length - 1; index > 0; index -= 1) {
    const other = Math.floor(rng() * (index + 1));
    [copy[index], copy[other]] = [copy[other], copy[index]];
  }
  return copy;
}

export function weightedPick<T>(entries: readonly { item: T; weight: number }[], rng: () => number): T {
  const total = entries.reduce((sum, entry) => sum + Math.max(0, entry.weight), 0);
  if (total <= 0) return entries[0].item;
  let roll = rng() * total;
  for (const entry of entries) {
    roll -= Math.max(0, entry.weight);
    if (roll <= 0) return entry.item;
  }
  return entries[entries.length - 1].item;
}

export function createSeed(): string {
  return `WM-${Date.now().toString(36).toUpperCase()}-${Math.floor(Math.random() * 0xffffff).toString(36).toUpperCase().padStart(5, "0")}`;
}
